<template>
    <div>
        <div class="row mr-0 mb-2"
            v-for="(item, i) in state" :key="i"
        >
            <text-select
                class="col"
                :options="optionsLang"
                :name="`jazyk[${i}][lang_key]`"
                :value="item.lang_key"
            ></text-select>
            <select class="col" v-model="item.level_key" :name="`jazyk[${i}][level_key]`">
                <option v-for="(level, index) in optionsLevel" :key="index"
                    v-text="level"
                    :value="index"
                ></option>
            </select>
        </div>
        <button class="btn btn-outline-primary" @click.prevent="addLanguage()">Přidat</button>
    </div>
</template>

<script>
    export default {
        props: [
            'options-lang',
            'options-level',
            'selected'
        ],

        data: () => ({
            state: []
        }),

        methods: {
            addLanguage() {
                this.state.push({
                    lang_key: null,
                    level_key: false
                });
            }
        },

        mounted() {
            let that = this;

            if (! this.selected.length) {
                this.addLanguage();
                return;
            }

            this.selected.forEach((item) => {
                that.state.push({
                    lang_key: item.lang_key,
                    level_key: item.level_key
                })
            });
        }
    }
</script>

<style lang="scss">
</style>
